module.exports = "https://web-assets.ifttt.com/packs/media/components/check2-3e78659a.svg";